// extracted by mini-css-extract-plugin
export var copyableField = "_ns-4";
export var customerBadge = "_ns-0";
export var customerInfoTitle = "_ns-2";
export var details = "_ns-1";
export var dropdownContainer = "_ns-5";
export var dropdownImage = "_ns-6";
export var editAssigneeForm = "_ns-a";
export var editButton = "_ns-3";
export var email = "_ns-7";
export var hidden = "_ns-d";
export var input = "_ns-8";
export var saveButton = "_ns-b";
export var shopifyIcon = "_ns-c";
export var suggestionBadge = "_ns-e";
export var suggestionText = "_ns-f";
export var username = "_ns-9";